import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-card-title',
  templateUrl: './av-card-title.component.html',
  styleUrls: ['./av-card-title.component.scss']
})
export class AvCardTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
